import {DeclarativeMutationConfig, Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {DuplicateNovaAgentInput, DuplicateNovaAgentMutation} from './__generated__/DuplicateNovaAgentMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

// Returns an edge so the copy is appended to its category's connection without a catalogue refetch.
// The copy always lands in the *source's* category, so the caller already knows the connection
// parent — the same `NovaStudioCatalogue_agents` key `CreateNovaAgentMutation` appends to.
// `categoryConnectionParentId` is client-only: it is the parent record's relay id, not a field the
// server accepts, so it is stripped from the input before the request goes out.
const mutation = graphql`
	mutation DuplicateNovaAgentMutation($input: DuplicateNovaAgentInput!) {
		duplicateNovaAgent(input: $input) {
			agent {
				node {
					id
					name
					title
					description
					categoryId
				}
			}
		}
	}
`;

function getConfigs(categoryConnectionParentId: string): DeclarativeMutationConfig[] {
	return [
		{
			type: 'RANGE_ADD',
			parentID: categoryConnectionParentId,
			connectionInfo: [
				{
					key: 'NovaStudioCatalogue_agents',
					rangeBehavior: 'append',
				},
			],
			edgeName: 'agent',
		},
	];
}

export type DuplicateNovaAgentMutationInput = MutationInput<DuplicateNovaAgentInput> & {
	categoryConnectionParentId: string;
};

function commit(
	environment: Environment,
	input: DuplicateNovaAgentMutationInput,
	onSuccess?: RelayOnCompleted<DuplicateNovaAgentMutation>,
	onError?: RelayOnError
): Disposable {
	const {categoryConnectionParentId, ...mutationInput} = input;
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...mutationInput}};

	return commitMutation<DuplicateNovaAgentMutation>(environment, {
		mutation,
		variables,
		configs: getConfigs(categoryConnectionParentId),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
